(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Reaction', Reaction);

    Reaction.$inject = ['$resource'];

    function Reaction ($resource) {
        var resourceUrl =  'api/reactions/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/reactions/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
